import { render, staticRenderFns } from "./UserSignatures.vue?vue&type=template&id=3495d9d6&"
import script from "./UserSignatures.vue?vue&type=script&lang=js&"
export * from "./UserSignatures.vue?vue&type=script&lang=js&"
import style0 from "./UserSignatures.vue?vue&type=style&index=0&id=3495d9d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports